import { red } from '@mui/material/colors'
import { ValueOf } from '../utils/utilTypes'

export const color = {
  plum: '#5B1934',
  plumDeep: '#361222',
  plumMid: '#794FB7',
  plumMidSoft: '#B199D5',
  plumMidPale: '#DDD3ED',
  plumLight: '#F7F2F4',
  plumSoft: '#A96F82',
  plumPale: '#EDE1D2',
  brightBlue: '#4F56CB',
  blueDark: '#393F54',
  orange: '#EF643A',
  gold: '#C08D39',
  coral: '#DE6D47',
  brick: '#A54332',
  mauve: '#A87D8D',
  greyBlue: '#6D7386',
  beigeDark: '#EDE7E1',
  beige: '#F8F0E8',
  beigeLight: '#F6F3F0',
  white: '#FFFFFF',
  grey1: '#F2F2F2',
  grey2: '#EBEBEB',
  grey3: '#B5B5B5',
  grey4: '#8D8D8D',
  grey5: '#5E5E5E',
  black: '#222222',
  green: '#4DBA99',
  greenLight: '#e5faf3',
  greenDark: '#146850',
  yellow: '#FFC83C',
  yellowLight: '#FAF4E5',
  magenta: '#E63946',
  red: '#B80000',
  redDeep: '#8C1D18',
  redLight: red[50],
  redDark: red[900],
  transparent: 'transparent',
  modalBackdrop: '#00000060',
  greenBackground: '#F2FDF9',
  redBackground: '#FDF9F5',
  greyBackground: '#F8F8F8',
}
export type ThemeColor = ValueOf<typeof color>
